import { DataHandlerUser, User } from "luxedo-data"

class UserRepository {
	user: User = $state()

	constructor() {
		DataHandlerUser.addListener((ids) => {
			if (ids.length > 0) this.user = DataHandlerUser.get(ids[0])
		})
	}
}

export const userRepo = new UserRepository()
